import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../../api/axiosConfig";
import { blogImageSrc } from "../../api/blogImage";
import Breadcrumb from "../../components/Breadcrumb";

function ExamNoteContent() {
  const { id } = useParams();
  const [note, setNote] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);

    api
      .get(`/exam-notes/contents/${id}`)
      .then((res) => {
        if (!cancelled) setNote(res.data.content || null);
      })
      .catch(() => {
        if (!cancelled) setNote(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) return <p className="text-center py-5">Loading note...</p>;
  if (!note) return <p className="text-center py-5">Note not found.</p>;

  return (
    <>
      <Breadcrumb title={note.heading} path="Exam wise notes" />
      <section className="single-blog-section py-120">
        <div className="container">
          <div className="col-lg-8 mx-auto">
            <p className="exam-note-back">
              <Link to="/exam-notes">Exam wise notes</Link>
            </p>
            <h2 className="single-blog-title">{note.heading}</h2>
            {note.photo ? (
              <img
                className="exam-note-photo"
                src={blogImageSrc(note.photo)}
                alt=""
              />
            ) : null}
            <div
              className="single-blog-content"
              dangerouslySetInnerHTML={{ __html: note.content || "" }}
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default ExamNoteContent;
